import { render, staticRenderFns } from "./AcnCertn.vue?vue&type=template&id=8e318b56"
import script from "./AcnCertn.vue?vue&type=script&lang=js"
export * from "./AcnCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e318b56')) {
      api.createRecord('8e318b56', component.options)
    } else {
      api.reload('8e318b56', component.options)
    }
    module.hot.accept("./AcnCertn.vue?vue&type=template&id=8e318b56", function () {
      api.rerender('8e318b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/AcnCertn.vue"
export default component.exports